import { useMutation } from 'urql';
import { MUTATION_EXCHANGE_OAUTH_TOKEN, MUTATION_GET_OAUTH_TOKEN, LOGIN, RESET_PASSWORD, SEND_EMAIL_RESET_PASSWORD, SEND_EMAIL_RESET_PASSWORD_BY_EMAIL } from './graphql';
import { ExchangeOAuthTokenMutation, ExchangeOAuthTokenMutationVariables, GetOAuthTokenMutation, GetOAuthTokenMutationVariables, MutationResetPasswordArgs, MutationSendEmailResetPasswordByEmailArgs, ResetPasswordMutation, SendEmailResetPasswordByEmailMutation } from '../../../gql/graphql';

export const useLogin = (query?: any) => {
    const [{ data, fetching, error }, execute] = useMutation((query || LOGIN));
    return { execute, data, fetching, error };
}

export const useSendEmailResetPasswordByEmail = (query?: any, options?: any) => {
    const [results, execute] = useMutation<SendEmailResetPasswordByEmailMutation>((query || SEND_EMAIL_RESET_PASSWORD_BY_EMAIL));
    return {
        ...results,
        execute: (data: MutationSendEmailResetPasswordByEmailArgs) => execute(data, options),
        data: results.data?.SendEmailResetPasswordByEmail,
    };
}

export const useSendEmailResetPassword = (query?: any) => {
    const [{ data, fetching, error }, execute] = useMutation((query || SEND_EMAIL_RESET_PASSWORD));
    return { execute, data, fetching, error };
}

export const useResetPassword = (query?: any) => {
    const [results, execute] = useMutation<ResetPasswordMutation>((query || RESET_PASSWORD));
    return {
        ...results,
        execute: (data: MutationResetPasswordArgs) => execute(data),
        data: results.data?.ResetPassword,
    };
}

export const useGetOAuthToken = (query?: any) => {
    const [{ data, fetching, error }, execute] = useMutation<GetOAuthTokenMutation>((query || MUTATION_GET_OAUTH_TOKEN));
    return {
        execute: (data: GetOAuthTokenMutationVariables) => execute(data),
        data,
        fetching,
        error
    };
}

export const useExchangeOAuthToken = (query?: any) => {
    const [{ data, fetching, error }, execute] = useMutation<ExchangeOAuthTokenMutation>((query || MUTATION_EXCHANGE_OAUTH_TOKEN));
    return {
        execute: (data: ExchangeOAuthTokenMutationVariables) => execute(data),
        data,
        fetching,
        error
    };
}
